import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-referenc-master',
  templateUrl: './referenc-master.component.html',
  styleUrls: ['./referenc-master.component.scss']
})
export class ReferencMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
